import { createSelector } from "reselect"
import { IShortcut } from "../../models"
import { IShortcuts } from "./index"

const getShortcuts = (state: IShortcuts): Record<string, IShortcut> =>
    state.shortcuts

export const getShortcutsArray = createSelector(
    [getShortcuts],
    (shortcuts): IShortcut[] => Object.values(shortcuts),
)

export interface SortedShortcuts {
    sortedShortcuts: IShortcut[]
}

export const getSortedShortcuts = createSelector(
    [getShortcutsArray],
    (shortcuts): SortedShortcuts => ({
        sortedShortcuts: shortcuts.sort((a, b) =>
            a.title.localeCompare(b.title),
        ),
    }),
)

const getFilter = (state: IShortcuts): string => state.filter

export interface FilteredShortcuts {
    filteredShortcuts: IShortcut[]
}

export const getFilteredShortcutsByTitle = createSelector(
    [getSortedShortcuts, getFilter],
    ({ sortedShortcuts }, filter): FilteredShortcuts => ({
        filteredShortcuts: sortedShortcuts.filter((shortcut) =>
            shortcut.title.toLowerCase().includes(filter.toLowerCase()),
        ),
    }),
)
